import React from 'react';
import moment from 'moment';
import { CoreLink } from '@uncinc/react-drupal-core';
import WysiwygField from '../WysiwygField';

import i18next from '../../config/i18next';


import './style.scss';

const SearchResult = ({ entity, ...props }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed']);
  const type = entity.getIn(['type', 0, 'target_id']);
  const url = entity.getIn(['paths', 'nl']);
  const date = moment(entity.getIn(['created', 0, 'value'], '-'));

  return (
    <div className="SearchResult">
      <CoreLink to={url} className="overlapping-link" />
      <div className="SearchResult__type">{i18next.t(type)}</div>
      <div className="SearchResult__title">{title}</div>
      <div className="SearchResult__date">{date.format('DD-MM-YYYY')}</div>
      <div className="SearchResult__url">http://www.NBBU.nl{url}</div>
      {body && (
        <WysiwygField
          property="schema:text"
          className="SearchResult__body"
          html={body}
        />
      )}
    </div>
  );
};

export default SearchResult;
